export default "/build/static/fonts/Whitney-SemibldItal_Web.woff";